import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { Popover } from './popover'
import { popperSmartPositionMod } from './popover-utils'

import styles from './error-popover.module.css'

const propTypes = {
    error: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    placement: PropTypes.string
}

const defaultProps = {
    placement: 'bottom'
}

/**
 * Error popover component. Renders an error using a <Popover> or just the
 * untouched children if there is none.
 * This is the successor of `components/form/error-popover.js`.
 * @author Andy Wermke
 */
class ErrorPopover extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isErrorPopoverVisible: false
        }

        this.showErrorPopover = this.showErrorPopover.bind(this)
        this.hideErrorPopover = this.hideErrorPopover.bind(this)
    }

    render() {
        const { children, error, placement } = this.props

        const arrowClassName = cx(styles['error-popper-triangle'], {
            [styles['error-popper-triangle-top']]: placement === 'top',
            [styles['error-popper-triangle-bottom']]: placement === 'bottom'
        })

        const className = cx('t3sel-error-popover', styles['error-popper'], {
            [styles['error-popper-top']]: placement === 'top',
            [styles['error-popper-bottom']]: placement === 'bottom',
            [styles['hidden']]: !error || !this.state.isErrorPopoverVisible
        })

        return (
            <Popover
                content={error && error.message}
                additionalModifiers={[popperSmartPositionMod]}
                {...{ arrowClassName, className, placement }}
                onTargetFocus={this.showErrorPopover}
                onTargetBlur={this.hideErrorPopover}
                onTargetMouseEnter={this.showErrorPopover}
                onTargetMouseLeave={this.hideErrorPopover}
            >
                {children}
            </Popover>
        )
    }

    showErrorPopover() {
        this.setState({ isErrorPopoverVisible: true })
    }

    hideErrorPopover() {
        this.setState({ isErrorPopoverVisible: false })
    }
}

ErrorPopover.propTypes = propTypes
ErrorPopover.defaultProps = defaultProps

export { ErrorPopover }
